import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/customer';
import Form from './Form';
import FormChangePassword from'./FormPassword';

export class Update extends React.Component { 

	render () {
		return (
			<div>
				<div className="ui grid">
					<div className="eight wide column">
						<h2>Edycja danych firmy</h2>
						<Form action={this.props.actions.save} fetchModel={this.props.actions.fetchCustomer} />
					</div>
					<div className="eight wide column">
						<h2>Zmiana hasła</h2>
						<FormChangePassword action={this.props.actions.savePassword} />
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Update);


/** WEBPACK FOOTER **
 ** ./js/views/customer/Update.js
 **/